import { ResponsiveSection } from '@stitch-fix/mode-react';
import type { NextPage } from 'next';
import { Layout } from '../../components/Layout';
import { OneTrustContent } from '../../components/OneTrustContent/OneTrustContent';
import { SEOData } from '../../components/SEOData';

const GiftCardTermsPage: NextPage = () => {
  return (
    <Layout viewEventTrackingName="corporate">
      <SEOData
        title="Gift Card Terms | Stitch Fix"
        robots="noindex, nofollow"
      />
      <ResponsiveSection mt="0" width={{ sm: 'full-bleed' }} gutter="none">
        <OneTrustContent documentID="2e8fda21-f066-4339-9965-3c6378266796" />
      </ResponsiveSection>
    </Layout>
  );
};

export default GiftCardTermsPage;
